<div class="custom-modal" *ngIf="cModal()">
  <div class="modal-contents">
    <form [formGroup]="currentCreditFormGroup">
      <h3>Assign Payment Credits</h3>
      <table class="table is-bordered">
        <tr>
          <td>Examinee ID</td>
          <td><input type="text" class="input is-small" formControlName="form_testtakerId"></td>
        </tr>
        <tr>
          <td>Current Credit</td>
          <td><input type="text" class="input is-small" formControlName="from_currentCredit" min="0"></td>
        </tr>
        <tr>
          <td>Assignment</td>
          <td><input type="number" min="0" class="input is-small" formControlName="form_credits"></td>
        </tr>
        <tr>
          <td>Assignment type</td>
          <td>
            <ng-container *ngFor="let assignment of availableCreditTypes">
              <input type="radio" [id]="assignment" [value]="assignment" formControlName="from_assignmentType">&nbsp;
              <label [for]="assignment">{{assignment}}</label>&nbsp;
            </ng-container>
          </td>
        </tr>
        <tr *ngIf="jurisInstitutionsList && jurisInstitutionsList.length > 0">
          <td>Test centre</td>
          <td>
            <select for="instit_list" formControlName="instit_list">
              <option value="" disabled selected>Please select a test centre</option>
              <option *ngFor="let centre of jurisInstitutionsList" [value]="centre.group_id">
                {{parseInstitName(centre)}}
              </option>
            </select>
          </td>
        </tr>
      </table>
    </form>
    <modal-footer [pageModal]="pageModal"></modal-footer>
  </div>
</div>
